class SubscriptionInput extends HTMLElement {
  constructor() {
      super();
      this.buttonSwitcher = this.querySelector('button');
      this.buttonSwitcher.addEventListener('click', this.onButtonClick.bind(this));
      this.cart = document.querySelector(window.deployerAdapter.cartDrawerSection);

      console.log('cart', this.cart);
  }

  onButtonClick(event) {
    console.log('onButtonClick');
      event.preventDefault();
      this.buttonSwitcher.setAttribute('aria-disabled', true);
      this.buttonSwitcher.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.switchToSubscription(event.target.dataset.line, event.target.dataset.sellingPlan, event.target.dataset.quantity);
  }

  switchToSubscription(line, selling_plan, quantity) {
    console.log('switchToSubscription');
    console.log({line, selling_plan, quantity});

      const body = JSON.stringify({
      line,
      selling_plan,
      quantity,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
          return response.json();
      })
      .then((response) => {
          this.cart.refreshCart();
      })
      .then(() => {
          this.buttonSwitcher.setAttribute('aria-disabled', true);
          this.buttonSwitcher.querySelector('span').classList.add('hidden');
          this.buttonSwitcher.classList.remove('loading');
      })
      .catch((error) => {
          console.log(error);
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('DeployerCartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
      });
  }
}
customElements.define('subscription-input', SubscriptionInput);